<template>
  <div class="enroll-fail">
    <div class="fail-form">
      <div class="title">
        <div>{{ year }}河北传媒学院高考录取结果</div>
      </div>
      <div class="form-body">
        <img
          src="../../../assets/enroll/no_enroll.png"
          alt=""
          class="img-fail"
        />
        <div class="fail-text">抱歉，未查询到您的录取结果!</div>
        <div class="fail-tip">
          <div>你输入的信息为：</div>
          <div>考生号：{{ info.number }} ，身份证号：{{ info.idCard }}</div>
        </div>

        <div @click="$emit('navBack')" class="btn-close">关闭</div>
      </div>
    </div>

    <div v-if="!showBatchList" @click="$emit('toggle-batch')" class="btn-view-batch">
      查看{{ year }}年高考录取批次列表
      <i style="margin-left: 10px" class="el-icon-caret-bottom"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoEnroll",
  props: {
    info: Object,
    showBatchList: Boolean,
  },
  data() {
    return {
      year: null,
    };
  },
  created() {
    this.year = new Date().getFullYear();
  },
};
</script>

<style lang="scss" scoped>
.enroll-fail {
  background: #fff;
  padding-bottom: 20px;

  .fail-form {
    position: relative;
    background: #ffffff;
    border: 1px solid #700005;
    border-radius: 8px;
    width: 800px;
    box-sizing: border-box;
    max-width: 100%;
    overflow: hidden;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -64px;
    margin-bottom: -64px;

    .title {
      position: relative;
      font-size: 22px;
      color: #fff;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: #700005;
      opacity: 1;
      .back {
        position: absolute;
        top: 0;
        left: 24px;
        font-size: 18px;
        font-weight: 100;
        cursor: pointer;
      }
    }
    .form-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 48px;

      .img-fail {
        width: 126px;
      }

      .fail-text {
        color: #700005;
        font-size: 24px;
        margin-top: 16px;
        margin-bottom: 8px;
      }
      .fail-tip {
        color: rgba(83, 83, 83, 1);
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 30px;
        margin-top: 20px;
        text-align: center;
      }
    }

    .btn-close {
      width: 172px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      background: #8f000b;
      opacity: 1;
      border-radius: 8px;
      margin: 10px 0;
    }
  }
}

.btn-view-batch {
  cursor: pointer;
  width: 800px;
  max-width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #700005;
  opacity: 1;
  border-radius: 100px;
  margin: 40px auto 0;
  color: #700005;
}

@media only screen and (max-width: 600px) {
  .btn-view-batch {
    width: 93%;
    font-size: 12px;
    height: 34px;
    margin-top: 30px;
  }

  .enroll-fail {
    padding-bottom: 30px;
    .fail-form {
      top: -40px;
      margin-bottom: -40px;
      width: 93%;

      .title {
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        .back {
          left: 8px;
          font-size: 12px;
          font-weight: 300;
        }
      }
      .form-body {
        .btn-close {
          width: 152px;
          height: 40px;
          line-height: 40px;
        }
        padding: 20px 15px;
        .img-fail {
          width: 86px;
        }
        .fail-text {
          font-size: 16px;
          margin-top: 16px;
          margin-bottom: 8px;
        }
        .fail-tip {
          font-size: 13px;
          line-height: 20px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
    }

    .info-wrapper {
      width: 100%;
      margin-top: 5px;
      .top {
        padding-bottom: 6px;
        .info-img {
          width: 18px;
          margin-right: 10px;
        }
      }
      .info-content {
        font-size: 14px;
        color: #535353;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 6px;
        > div {
          padding: 8px 0;
        }
        > div:not(:last-child) {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>